define('ReorderItems.List.View.LimitQty', [
  'ReorderItems.List.View',
  'LimitItemQuantity.MyAccount.Helper',
  'underscore'
], function LimitItemQuantityMyAccount(
  ReorderItemsListView,
  Helper,
  _
) {
  'use strict';

  _.extend(ReorderItemsListView.prototype, {
    addToCart: _.wrap(ReorderItemsListView.prototype.addToCart, function addToCart(fn, e) {
      var event = _.toArray(arguments).slice(1);
      if (Helper.validateAddToCart(this, e, true)) {
        fn.apply(this, event);
      }
    })
  });
});
